import router from '@/router'

let accessCode = {
  getAccessCode() {
    const code = localStorage.getItem('accessCode')
    const codeValidity = new Date(JSON.parse(localStorage.getItem('codeValidity')))
    const now = new Date()
    if (code && codeValidity && now < codeValidity) {
      if (code) {
        const refreshedCodeValidity2 = new Date(now.getTime() + 24 * 60 * 60 * 1000)
        localStorage.setItem('codeValidity', JSON.stringify(refreshedCodeValidity2))
        return JSON.parse(localStorage.getItem('accessCode'))
      }
    } else {
      this.removeData()
      if (router) {
        router.push({
          name: 'home'
        })
      }
      return null
    }
  },

  setAccessCode(code) {
    const now = new Date()
    const codeValidity = new Date(now.getTime() + 24 * 60 * 60 * 1000)
    localStorage.setItem('accessCode', JSON.stringify(code))
    localStorage.setItem('codeValidity', JSON.stringify(codeValidity))
  },

  removeData() {
    localStorage.removeItem('accessCode')
    localStorage.removeItem('surveyId')
    localStorage.removeItem('codeValidity')
  },
}

export default accessCode
